import { DataGrid } from '@twilio-paste/core/data-grid';

import { useApp } from '../../../modules/Apps';
import { CreateTargetsDrawer } from '../TargetsForm';
import { EditTargetsDrawer } from '../TargetsForm/EditTargetsDrawer';
import { ReadOnlyTargetDrawer } from '../TargetsForm/ReadOnlyTargetDrawer';

import { TargetsTableContent } from './TargetsTableContent';
import { useTargetsTableContext } from './TargetsTableContext';
import { TargetsTableHeader } from './TargetsTableHeader';

interface TargetsTableProps {
  appId: string;
}

export function TargetsTable({ appId }: TargetsTableProps) {
  const { data: app, isLoading, isError } = useApp(appId);
  const { createTargetDrawerState, editTargetDrawerState, editingTarget, viewTargetDrawerState } =
    useTargetsTableContext();

  return (
    <>
      <DataGrid aria-label="Targets table">
        <TargetsTableHeader />
        <TargetsTableContent app={app} isError={isError} isLoading={isLoading} />
      </DataGrid>
      {app && <CreateTargetsDrawer appId={app.appId} state={createTargetDrawerState} />}
      {app && editingTarget && (
        <EditTargetsDrawer target={editingTarget} state={editTargetDrawerState} />
      )}
      {app && editingTarget && (
        <ReadOnlyTargetDrawer target={editingTarget} state={viewTargetDrawerState} />
      )}
    </>
  );
}
